// @ts-nocheck
import {Column} from 'react-table'
import {PropertiesNameCell} from './PropertiesNameCell'
import {PropertiesProjectCell} from './PropertiesProjectCell'
import {PropertiesActionsCell} from './PropertiesActionsCell'
import {PropertiesCustomHeader} from './PropertiesCustomHeader'
import {PropertiesStateCell} from './PropertiesStateCell'
import {PropertiesCityCell} from './PropertiesCityCell'
import {PropertiesIdentifierCell} from './PropertiesIdentifierCell'
import {Properties} from '../../core/_models'

const propertiesColumns: ReadonlyArray<Column<Properties>> = [
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_IDENTIFIER'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'identifier',
    Cell: ({...props}) => <PropertiesIdentifierCell property={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_NAME'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'name',
    Cell: ({...props}) => <PropertiesNameCell property={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_STATE'
        className='fs-8 text-center flex-row-fluid flex-center'
      />
    ),
    id: 'state',
    Cell: ({...props}) => <PropertiesStateCell property={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='COMMON.INPUT_CITY'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'city',
    Cell: ({...props}) => <PropertiesCityCell property={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='MENU.PROJECTS'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'project',
    Cell: ({...props}) => <PropertiesProjectCell property={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <PropertiesCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='text-center min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <PropertiesActionsCell data={props.data[props.row.index]} />,
  },
]

export {propertiesColumns}
